



















































import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { Article } from "@/api/models/accesPlateformeBeneficiaires/news";
import { BModal } from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: { 
    FeatherIcon,
    BModal
   },
  name: "details-news"
})
export default class DetailsNews extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: null }) news!: Article;
  showModal: boolean = this.show;

  @Watch("show", { immediate: true })
  onShowChanged(newVal: boolean) {
    this.showModal = newVal;
  }

  onModalChange(val: boolean) {
    this.showModal = val;
    this.$emit("update:show", val);
  }

  closeModal() {
    this.showModal = false;
    this.$emit("close");
  }
}
